import { Component, AfterViewInit, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { NgForm, FormControl, FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl } from '@angular/forms';
import { FormLabelComponent } from '../../components/form/label/label.component';
import { FormMessageComponent } from '../../components/form/message/message.component';
import { ValidationService } from '../../shared/services/validation.service';
import { Utility } from '../../common/utility';
import { RegisterModel } from '../../models/register/register.model';
import { BaseUrl } from '../../shared/urls/base.url';
import { UserUrl } from '../../shared/urls/user.url';
import { DialogService } from '../../shared/services/dialog.service';
import { AppConstants } from './../../shared/constants/constants';
import { RegisterService } from '../../pages/register/register.service';
import { UpdatePatientInformationService } from './update-patient-information.service';
import { ShareService } from '../../shared/services/share.service';


@Component({
  selector: 'app-update-patient-information',
  templateUrl: 'update-patient-information.component.html',
  providers: [UpdatePatientInformationService]
})
export class UpdatePatientInforComponent implements OnInit {
  userId: string;
  public registerForm: FormGroup;
  public registerModel = new RegisterModel();

  public countryData = [];
  public titleData = [];
  public collegeData = [];
  public sexData = [];
  public countryofbirthData = [];
  public healthinsuranceData = [];
  public partyTypes = [];
  public partyData = [];
  public billingcountryData = [];
  public marketingData: any;
  public occupationData = [];
  public isStudent = false;
  public appConstants = AppConstants;
  constructor(private formBuilder: FormBuilder,
    public utility: Utility,
    private dialogService: DialogService,
    private activeRouter: ActivatedRoute,
    private shareService: ShareService,
    public updatePatientInformationService: UpdatePatientInformationService) {
     this.createForm();
    }

  ngOnInit() {
    this.updatePatientInformationService.getCountryList().subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          this.countryData = data;

        }
      }
    );
    this.sexData = this.updatePatientInformationService.getSexData();
    this.partyTypes = this.updatePatientInformationService.getTypeParty();
    this.updatePatientInformationService.getInit().subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          //this.partyData = data[''];
          this.titleData = data['titles'];
          this.collegeData = data['colleges'];
          this.occupationData = data['occupations'];
          this.healthinsuranceData = data['healthInsurances'];
          this.marketingData = data['marketings'];
          this.getPartyData();
          this.getInitData();
        }
      }
    );
  }

  getCountryData() {
    this.updatePatientInformationService.getCountryList().subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          this.countryData = data;
        }
      }
    );
  }

  getInitData() {
    if (localStorage.getItem(this.appConstants.activeLink.userId)) {
      this.updatePatientInformationService.getPatientDetail(localStorage.getItem(this.appConstants.activeLink.userId)).subscribe(
        (result) => {
          if (result) {
            const data = result.json();
            this.registerModel = data;
            this.registerForm.controls['dateOfBirth'].setValue(this.registerModel.dateOfBirth);

            // Check Occupation Student
            if (this.registerModel.occupationId) {
              this.isStudent = this.occupationData.find(c => c.id === this.registerModel.occupationId).name === 'Student';
            }
          }
        }
      );
    }
  }

  getPartyData() {
    this.updatePatientInformationService.getParty().subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          this.partyData = data['list'];
        }
      }
    );
  }


  createForm() {
    const dateOfBirth = this.registerModel.dateOfBirth;
    this.registerForm = this.formBuilder.group({
      firstName: ['', [Validators.required]],
      middleName: [''],
      surName: ['', [Validators.required]],
      titleId: ['', [Validators.required]],
      sexId: [null, [Validators.required]],
      birthDay: [dateOfBirth, [Validators.required, ValidationService.isValidDateOfBirth]],
      address1: ['', [Validators.required]],
      address2: ['', [Validators.required]],
      address3: [''],
      countryId: [null, [Validators.required]],
      countryOfBirthId: [null, [Validators.required]],
      email: ['', [Validators.required, ValidationService.isValidEmail]],
      occupationId : [null, [Validators.required]],
      reference: [''],
      patientREF: [''],
      userName: [''],
      postCode: [''],
      isIncludeInMarketing: [false],
      isSeparateBillingAddress: [false],
      billingAddress1: [''],
      billingAddress2: [''],
      billingAddress3: [''],
      billingCountryId: [null],
      billingPostCode: [''],
      homePhone: [''],
      workPhone: [''],
      mobilePhone: [''],
      policyNumber: [''],
      studentId: [''],
      healthInsuranceId: [null],
      healthPolicyNumber: [null],
      college: [null],
      partyTypeId: [''],
      partyId: [''],
      billCountry: [''],
      marketingId: [null],
      dateOfBirth: [''],
      passportOrIdNumber: ['']
  });
  }

  onDobChange(e) {
    ValidationService.validationDate(this.registerForm.controls['birthDay'], e);
    const dateOfBirth = this.utility.convertDateToString(this.registerForm.controls['birthDay'].value);
    this.registerForm.controls['dateOfBirth'].setValue(dateOfBirth);
}
  onDobInput(e) {

  }
  inputMaxLength() {
    return 50;
  }

  inputMaxLengthPhone() {
    return 24;
  }

  addSeparateBillingAddress(e) {
    if (this.registerModel.billingAddress1 === '') {
      this.registerModel.billingAddress1 = this.registerModel.address1;
    }
    if (this.registerModel.billingAddress2 === '') {
      this.registerModel.billingAddress2 = this.registerModel.address2;
    }
    if (this.registerModel.billingAddress3 === '') {
      this.registerModel.billingAddress3 = this.registerModel.address3;
    }
    if (this.registerModel.billingPostCode === '') {
      this.registerModel.billingPostCode = this.registerModel.postcode;
    }

    // Need to fix, BE must passing empty value is null
    if (this.registerModel.billingCountryId == null) {
      this.registerModel.billingCountryId = this.registerModel.countryId;
    }
  }

  onChangeOccupation() {
    this.isStudent = this.occupationData.find(c => c.id === this.registerModel.occupationId).name === 'Student';
  }

  onSubmit() {
    if (this.registerForm.valid && this.registerForm.dirty) {
      this.updatePatientInformationService.updatePatient(
        localStorage.getItem(this.appConstants.activeLink.userId), this.registerForm.value).subscribe(
        (result) => {
          if (result) {
            const data = result.json();
            this.dialogService.openSuccessDialog({ message: data.message });
            // dispatch change user info event to header component (fix bug SD10001680-268)
            const info = {
              firstName: this.registerForm.value.firstName,
              lastName: this.registerForm.value.surName
            };
            this.shareService.announceUserInfoUpdate(info);
          }
        }
      );
    }
  }


}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/update-patient-information/update-patient-information.component.ts